/**
 * HSL 等距分布调色板，避开相邻色相过近。
 * 任何数量都能产出区分度较高的颜色。
 */
export function generateColors(count: number, seedHue = 210): string[] {
  if (count <= 0) return [];
  const result: string[] = [];
  const goldenAngle = 137.508; // 黄金角
  for (let i = 0; i < count; i++) {
    const h = (seedHue + i * goldenAngle) % 360;
    const s = 65;
    const l = 55;
    result.push(`hsl(${h.toFixed(1)}, ${s}%, ${l}%)`);
  }
  return result;
}

/** 把 HSL 颜色转成带透明度的 rgba（用于 Chart.js fill） */
export function withAlpha(color: string, alpha: number): string {
  // 仅处理 hsl(...) 形式
  const m = color.match(/^hsl\(([^)]+)\)$/);
  if (!m) return color;
  const parts = m[1].split(',').map((s) => s.trim());
  return `hsla(${parts[0]}, ${parts[1]}, ${parts[2]}, ${alpha})`;
}
